import { createContext } from 'react';
export var RcMenuContext = createContext({
    menuId: '',
    autoClose: false,
    focusedMenuItemId: null,
    setFocusedMenuItemId: function () { return null; },
    closeMenu: function () { return null; },
});
